const DOMAIN_NAME = 'employeeLeaveManagementForUser';
const ROWS_PER_PAGE = 10;

export { DOMAIN_NAME, ROWS_PER_PAGE };



